import React from "react";
import styles from "./contact.module.scss";

const Contact = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.contact}>
          <h3>Want to get involved? Let us know!</h3>
          <p>
            Are you interested in using the FireSmart Hub for your community?
            Want to implement the FireSmart Hub in your region?
          </p>
        </div>
        <a href="mailto:contact@firesmarthub.ca" className={styles.action}>
          Join Us
        </a>
      </div>
    </div>
  );
};
export default Contact;
